<template>
  <div>
    <!-- disabledFetchingCountry: NO llamar a ip2c.org (tercero sin acuerdo) con la
         IP del visitante en cada mount del signup — fuga de privacidad en app de
         plata, + evita el race donde una respuesta tardía de ip2c pisa el país
         que el usuario ya eligió. El default queda en preferredCountries[0]=CL
         (los remitentes están en Chile) y onSelect emite +56 igual. -->
    <vue-country-code @onSelect="onSelect" :preferredCountries="preferredCountries" :disabledFetchingCountry="true">
    </vue-country-code> <span class="font-color-primary">+{{ this.selectedDialCode }}</span>
    <input type="hidden" name="dial_code" :value="selectedDialCode" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedDialCode : '',
      preferredCountries: [ 'CL', 'CO', 'VE' ]
    };
  },
  methods: {
     onSelect({name, iso2, dialCode}) {
       this.selectedDialCode = dialCode;
     },
  },
}
</script>

<style>
.vue-country-select {
  height: 45px;
}
</style>
